<script setup lang="ts">
import {
    SwitchRoot,
    type SwitchRootEmits,
    type SwitchRootProps,
    SwitchThumb,
    useForwardPropsEmits,
} from "radix-vue";
import { cn } from "@/lib/utils";

const props = defineProps<SwitchRootProps & { class?: string }>();
const emits = defineEmits<SwitchRootEmits>();

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
    <SwitchRoot
        v-bind="forwarded"
        :class="
            cn(
                'peer focus-visible:ring-z-primary-500 focus-visible:ring-offset-white data-[state=checked]:bg-z-primary-600 data-[state=unchecked]:bg-stone-200 dark:focus-visible:ring-stone-300 dark:focus-visible:ring-offset-z-primary-500 dark:data-[state=checked]:bg-stone-50 dark:data-[state=unchecked]:bg-stone-800 inline-flex h-[24px] w-[44px] shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
                props.class,
            )
        "
    >
        <SwitchThumb
            :class="
                cn(
                    'h-5 w-5 bg-white shadow-lg data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 dark:bg-z-primary-500 pointer-events-none block rounded-full ring-0 transition-transform',
                )
            "
        />
    </SwitchRoot>
</template>
